import { defineStore } from 'pinia'
import ApiService from '@/utils/ApiService'

export interface RedeSubrede {
  codRedeAutoAtndto: number
  codSubredeAutoAtndto: number
  nomRedeAutoAtndto: string
  nomSubredeAutoAtndto: string
}

export const useRedeSubredeStore = defineStore('redeSubrede', {
  state: () => ({
    loading: false,
    subredes: [] as RedeSubrede[],
    subredesSelecionadas: [] as RedeSubrede[],
    codRede: 10 // Banco24Horas (fixo por regra de negócio)
  }),

  getters: {
    /**
     * Texto para exibir no formulário principal
     * Ex: "Banco24Horas / VIP Banco24Horas / Exclusivo"
     */
    labelSelecionadas(state): string {
      if (!state.subredesSelecionadas.length) return ''

      return state.subredesSelecionadas
        .map(s => s.nomSubredeAutoAtndto)
        .join(', ')
    },

    /**
     * Granularidade conforme regras
     */
    granularidade(state): 'POR_REDE' | 'POR_SUBREDE' {
      return state.subredesSelecionadas.length === state.subredes.length
        ? 'POR_REDE'
        : 'POR_SUBREDE'
    } 
  },

  actions: {
    /**
     * Carrega redes/subredes do backend
     * Chama: GET http://localhost:8441/redes
     */
    async carregarSubredes() {
      this.loading = true
      try {
        const response = await ApiService.get<RedeSubrede[]>(
          process.env.VUE_APP_API_CAMPAIGN_ENDPOINT!,
          process.env.VUE_APP_API_REDE_SUBREDE_ROUTE!
        )

        this.subredes = Array.isArray(response) ? response : []
      } catch (error) {
        console.error('[RedeSubredeStore] Erro ao carregar subredes', error)
        this.subredes = []
      } finally {
        this.loading = false
      }
    },

    /**
     * Salva as subredes selecionadas no modal
     */
    selecionarSubredes(subredesSelecionadas: RedeSubrede[]) {
      this.subredesSelecionadas = subredesSelecionadas
    },

    /**
     * Limpa seleção
     */
    limpar() {
      this.subredesSelecionadas = []
    },

    // ✅ NOVO: sincroniza redes vindas do backend
    async setSelecionadasFromBackend(redes: Array<{ codRede: number; codSubrede: number }>) {
      // Garante que subredes estão carregadas antes de mapear
      if (!this.subredes.length) {
        await this.carregarSubredes()
      }

      this.subredesSelecionadas = redes
        .map(r => this.subredes.find(s => s.codSubredeAutoAtndto === r.codSubrede))
        .filter(Boolean) as RedeSubrede[]
    }
  }
})